import React from 'react'
import {Modal} from 'react-bootstrap'
import {KTIcon} from '../../../_metronic/helpers'
import {DemandDemontageForm} from './components/DemandeDemontageForm'
import {DemandDemontageEditForm} from './components/DemandeDemontageEditForm'

const DemandeDemontageModal = ({
  show,
  vehiculeId,
  numeroVehicule,
  showModal,
  isEdition,
  demandeDemontageId,
  setData,
  marqueModele,
  typePiece,
  isRedirection,
  demandeId,
  typePieceHn,
  pieceInstance
}) => {
  return (
    <>
      <Modal
        size='lg'
        tabIndex={-1}
        aria-hidden='true'
        dialogClassName='modal-dialog modal-dialog-centered'
        show={show}
        onHide={() => showModal(false)}
        backdrop={true}
      >
        <div className='modal-content'>
          <div className='modal-header'>
            <h5 className='modal-title'>
              {isEdition
                ? `Modification d'une demande de démontage pour le véhicule n° ${numeroVehicule} ${marqueModele}`
                : `Demande de démontage pour le véhicule n° ${numeroVehicule} ${marqueModele}`}
            </h5>
            <div
              className='btn btn-icon btn-sm btn-light-primary ms-2'
              onClick={() => showModal(false)}
            >
              <KTIcon className='fs-2' iconName='cross' />
            </div>
          </div>
          {!isEdition && (
            <DemandDemontageForm
              vehiculeId={vehiculeId}
              numeroVehicule={numeroVehicule}
              showModalProp={showModal}
              setData={setData}
              typePiece={typePiece}
              isRedirection={isRedirection}
              demandeId={demandeId}
              typePieceHn={typePieceHn}
              pieceInstance={pieceInstance}
            />
          )}
          {isEdition && (
            <DemandDemontageEditForm
              vehiculeId={vehiculeId}
              showModalProp={showModal}
              demandeDemontageId={demandeDemontageId}
              numeroVehicule={numeroVehicule}
              setDataDemande={setData}
              demandeId={demandeId}
            />
          )}
        </div>
      </Modal>
    </>
  )
}

export {DemandeDemontageModal}
